<template>
    <div class='index'>
        <div style="position: absolute;top: 0;width: 100%;" v-if="qrcodedata&&gcfg">

            <van-swipe :autoplay="3000" :indicator-color="gcfg.BackgroundColor">
                <van-swipe-item v-for="(image, index) in qrcodedata.imgs_show" :key="index">
                    <img class="topimg" :src="image" />
                </van-swipe-item>
            </van-swipe>

            <van-button round v-if="qrcodedata.status!=1" v-on:click="duihuan_click()" :style="'line-height:33px;height:36px; margin:2em auto; display: block; color:white; background:'+gcfg.BackgroundColor">立即兑换</van-button>
            <van-button round v-else v-on:click="tiaozhuan()" :style="'line-height:33px;height:36px; margin:2em auto; display: block; color:white; background:'+gcfg.BackgroundColor">去兑换商品</van-button>
            <div class="text-con" v-if="qrcodedata">
                <div v-if="qrcodedata.qrscoreactivity.exchange_typedata=='qualification'">活动类型：<span>{{qrcodedata.qrscoreactivity.exchange_typedata_text}} 一劵兑换 {{qrcodedata.qrscoreactivity.exchange_numnumber}}个商品</span></div>
                <div v-else>活动类型：<span>{{qrcodedata.qrscoreactivity.exchange_typedata_text}} 一劵兑换{{qrcodedata.qrscoreactivity.score_numnumber}}积分</span></div>
                <div>活动时间：<span>{{qrcodedata.qrscoreactivity.starttime_text}} 至 {{qrcodedata.qrscoreactivity.endtime_text}}</span></div>
                <div>兑换码：<span>{{code}} {{qrcodedata.status==1?'【已兑换】':''}}</span></div>
            </div>
        </div>

        <cube-view></cube-view>

    </div>
</template>

<script>
    import CubeView from '@/components/TP/cube-view'
    import * as util from '@/utils/network'

    export default {
        components: {
            CubeView,
        },
        data() {
            return {
                qrcodedata: null,
                gcfg:[],
                code:this.$route.query.code,
            }
        },
        methods: {
            axios_Request: function() {
                var url = "/addons/qrcodeshop/api.code/showdata"
                let that = this;

                //这里直接调用网络接口
                util.get(url, {code:that.code},
                    function(result) {
                        console.log(result);
                        that.qrcodedata = result.data;
                        // 格式化显示时间
                        that.qrcodedata.qrscoreactivity.endtime_text = that.qrcodedata.qrscoreactivity.endtime_text.substring(0,10)
                        that.qrcodedata.qrscoreactivity.starttime_text = that.qrcodedata.qrscoreactivity.starttime_text.substring(0,10)

                        document.title = that.qrcodedata.qrscoreactivity.titletext
                        //that.$store.commit('setAct', result.data.activity);
                        //localStorage.setItem("ActData",JSON.stringify(result.data.activity))
                    },
                );
            },
            duihuan_click:function () {
                //这里根据code 和 userid  兑换 二维码
                var url = "/addons/qrcodeshop/api.code/duihuan"
                let that = this;
                util.get(url, {code:that.code},
                    function(result) {
                        console.log(result);
                        //兑换成功后 自动跳转
                        that.$router.push({path: 'Showactgoodlist', query: {actid: result.data.activity_id}})
                    },
                );
            },
            tiaozhuan:function () {
                let that = this;
                that.$router.push({path: 'Showactgoodlist', query: {actid: that.qrcodedata.activity_id}})
            }
        },
        created: function() {
            if(this.code == undefined){

            }else{
                this.axios_Request();
            }
            this.gcfg = this.$store.getters.getGcfg
        },
        watch:{
            "$store.state.gcfg": function(){
                this.gcfg = this.$store.getters.getGcfg
            }
        },
    }
</script>

<style scoped>
    .van-swipe-item img.topimg {
        display: block;
        height: 100%;
        width: 100%;
    }
    .text-con{
        text-align: center;
        font-size: 0.6em;
        font-weight: bold;
        line-height: 2.18em;
        margin-top: 2em;
    }
    .text-con span{
        font-weight: 100;
    }
</style>